import styled from 'styled-components';
import { ApModal, colors } from '@alixpartners/ui-components';

export const StyledModal = styled(ApModal)`
	.ap-modal-lightbox {
		background-color: rgba(50, 50, 50, 0.3);
	}
	.ap-modal-content {
		max-width: 960px;
		border-radius: 1px;
		box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.25);
		max-height: 100%;
		height: 600px;
	}

	.ap-modal-footer {
		padding: 0 32px;
		display: flex;
		height: 59px;
		min-height: 59px;

		.ap-button-group {
			margin-left: auto;
		}
	}

	.ap-modal-body {
		padding: 0;
		height: 100%;
		overflow: hidden;
		display: flex;
		flex-direction: column;
	}
`;

export const Content = styled.div`
	display: flex;
	height: 100%;
	overflow: hidden;
`;

export const CheckboxWrapper = styled.div`
	position: absolute;
	height: 59px;
	display: flex;
	align-items: center;
	padding: 0 32px;
	bottom: 0;
`;

export const CheckboxLabel = styled.div`
	font-size: 16px;
	color: ${colors.grey8};
`;

export const ScrollableWrapper = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	width: 100%;
	overflow: auto;

	section {
		min-width: unset;
		box-shadow: none;
		margin-top: 0;

		> span {
			display: none;
			& + span {
				display: none;
				& + div {
					display: none;
				}
			}
		}
	}

	.threshold-field {
		input {
			width: 185px;
		}
	}
`;

export const Title = styled.div`
	display: flex;
	font-size: 19px;
	font-weight: 500;
	line-height: 27px;
	color: ${colors.grey8};
	padding: 16px 32px 0 32px;

	span {
		padding-left: 16px;
		font-weight: 400;
		color: ${colors.grey5};
	}
`;
